import React, { useContext, useState } from "react";
import { ALL_PAYMENT_TERMS_QUERY } from "../../../graphql/PaymentTerms/PaymentTerms.graphql";
import { AddPaymentTermForm } from "../../../components/PaymentTerms";
import { ModalContext } from "../../../components/ModalProvider";
import DataTable from "../../../components/DataTable";
import { COLUMNS } from "./columns";
import PageHeader from "../../../components/PageHeader";
import PaymentTermFilters from "./PaymentTermFilters";
import { getFilterState, saveFilterState } from "../../../utils";

const PaymentTermsPage = () => {
  const INITIAL_FILTER_STATE = getFilterState("PAYMENT_TERMS_FILTERS", {
    Active: true
  });

  const { setModalOpen } = useContext(ModalContext);
  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const handleSetFilters = inputs => {
    saveFilterState("PAYMENT_TERMS_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () => handleSetFilters({ Active: true });

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={PaymentTermFilters}
        columns={COLUMNS}
        filters={filters}
        name="PaymentTerms"
        query={ALL_PAYMENT_TERMS_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Payment Terms"
        onAddClick={() =>
          setModalOpen(
            true,
            <AddPaymentTermForm onComplete={() => setModalOpen(false, "")} />
          )
        }
      />
      <DataTable
        columns={COLUMNS}
        dataQuery={ALL_PAYMENT_TERMS_QUERY}
        initialSortBy={[{ id: "TermCode", desc: false }]}
        name="PaymentTerm"
        where={filters}
        onRowClick={row =>
          setModalOpen(
            true,
            <AddPaymentTermForm
              data={row}
              onComplete={() => setModalOpen(false, "")}
            />
          )
        }
      />
    </React.Fragment>
  );
};
PaymentTermsPage.propTypes = {};
export default PaymentTermsPage;
